export default {
  server: "https://laportadistribuidor.ar",
  // server: "http://localhost:50005",
};
